import React from 'react';
import {IListColumnProps} from '../../src/@interfaces/components/List/IListColumnProps';
import {ListConfigNamedColumn} from '../../src/@types/components/List';
import {IListConfigRelationColumn} from '../../src/@interfaces/components/List/IListConfigRelationColumn';
import {IOrderModel} from '../../src/@interfaces/models/Order/IOrderModel';
import HasNewCommentIndicator from './HasNewCommentIndicator';

export default function OrderIndicatorsColumn(
        props: IListColumnProps<ListConfigNamedColumn<IListConfigRelationColumn>, IOrderModel>
) {
    return <div className="text-center">
        <HasNewCommentIndicator active={props.model.has_new_comments ?? false}/>
    </div>;
}
